// IMAGE SLIDER duplicate
let imgWrapper = document.querySelector(".section-showcase-slider-wrap .swiper-wrapper");
let imgSlides = imgWrapper.querySelectorAll(".swiper-slide");
let imgCount = imgSlides.length;

if (imgCount < 6) {
  let clonesNeeded = 6 - imgCount;
  for (let i = 0; i < clonesNeeded; i++) {
    let clone = imgSlides[i % imgCount].cloneNode(true);
    imgWrapper.appendChild(clone);
  }
}

// TEXT SLIDER duplicate
let textWrapper = document.querySelector(".section-showcase-slider-text-wrap .swiper-wrapper");
let textSlides = textWrapper.querySelectorAll(".swiper-slide");
let textCount = textSlides.length;

if (textCount < 6) {
  let clonesNeeded = 6 - textCount;
  for (let i = 0; i < clonesNeeded; i++) {
    let clone = textSlides[i % textCount].cloneNode(true);
    textWrapper.appendChild(clone);
  }
}

// text swiper
var textSwiper = new Swiper(".section-showcase-slider-text-wrap", {
  slidesPerView: 1,
  allowTouchMove: false,
  effect: "fade",
  fadeEffect: { crossFade: true },
  loop: true, // keep loop in sync
});

// image swiper
var swiper = new Swiper(".mySwiper.section-showcase-slider-wrap", {
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: "auto",
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 200,
    modifier: 2,
  },
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: textSwiper,
  },
});
